// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 927) return "js/927.js";
	if (chunkId === 745) return "js/745.js";
	if (chunkId === 789) return "js/789.js";
	// return url for filenames based on template
	return undefined;
};